export enum BreakpointWidth {
  maxWith = 960,
  tabletWidth = 768,
  mobileWidth = 575,
}

export const NewItemId = 'new-item-id';

export enum Language {
  en = 'en',
  ru = 'ru',
  pl = 'pl',
  by = 'by',
  ua = 'ua',
}

export const defaultLanguageKey = Language.en;

export enum UserRole {
  user = 'user',
  trainer = 'trainer',
  moderator = 'moderator',
  admin = 'admin',
  superAdmin = 'superAdmin',
}

export enum AccessScope {
  private = 'private',
  public = 'public',
}

export enum FileVisibility {
  public = 'public',
  private = 'private',
}

export enum PostsInteractionScope {
  all = 'all',
  subscribers = 'subscribers',
  nobody = 'nobody',
}

export enum AclAccess {
  ALLOW = 'allow',
  DENY = 'deny',
}

export enum ExerciseScope {
  private = 'private',
  publicRequest = 'publicRequest',
  publicReject = 'publicReject',
  public = 'public',
}

export enum ExerciseOptionType {
  integer = 'integer',
  fractional = 'fractional',
  time = 'time',
}

export enum TimerType {
  time = 'time',
}

export enum ProgramScope {
  private = 'private',
  protected = 'protected',
}

export enum FormMode {
  edit = 'edit',
  view = 'view',
}

export enum TrainingSetItemStatus {
  notStarted = 'notStarted',
  started = 'started',
  doLate = 'doLate',
  skipped = 'skipped',
  finished = 'finished',
}

export enum RelationStatus {
  requested = 'requested',
  rejected = 'rejected',
  approved = 'approved',
}

export const Header = {
  authorization: `authorization`,
};

export enum CommunityScope {
  private = 'private',
  public = 'public',
}

export enum AuthProvider {
  password = 'password',
  google = 'google.com',
  apple = 'apple.com',
  facebook = 'facebook.com',
}

export enum SubscriptionType {
  free = 'free',
  starter = 'starter',
  pro = 'pro',
  trainer = 'trainer',
}

export enum SubscriptionPeriod {
  annual = 'annual',
  monthly = 'monthly',
}

export enum SubscriptionScope {
  starter = 'starter',
  pro = 'pro',
  trainer = 'trainer',
}

export enum RestrictionScope {
  exercise = 'exercise',
  program = 'program',
  programItem = 'programItem',
  training = 'training',
  trainingGeneration = 'trainingGeneration',
  periodStatistics = 'periodStatistics',
}

export enum TrainingStatus {
  notStarted = 'notStarted',
  started = 'started',
  finished = 'finished',
}

export enum TrainingPeriod {
  week = 'week',
  month = 'month',
  threeMonth = '3month',
  sixMonth = '6month',
  oneYear = '1year',
  allTime = 'alltime',
}

export enum ExercisePropertyType {
  muscle = 'muscle',
  muscleGroup = 'muscleGroup',
  equipment = 'equipment',
  category = 'category',
  developedSkill = 'developedSkill',
}

/** At least one uppercase, one lowercase, one digit; min length enforced separately. */
export const PasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/;
export const FirebaseErrorCodes = [
  'auth/invalid-credential',
  'auth/email-already-in-use',
  'auth/too-many-requests',
  'auth/popup-closed-by-user',
];

export enum BugReportStatus {
  requested = 'requested',
  responded = 'responded',
  resolved = 'resolved',
  closed = 'closed',
}

export enum AppVariableType {
  string = 'string',
  number = 'number',
  boolean = 'boolean',
  json = 'json',
}

export enum SetType {
  warmUp = 'warmUp',
  normal = 'normal',
  failure = 'failure',
  drop = 'drop',
}

export enum AvatarTypes {
  square = 'square',
  round = 'round',
}

export enum AvatarSize {
  xs = 20,
  s = 32,
  m = 48,
  l = 92,
  xl = 150,
}

export enum UserConfigKey {
  theme = 'theme',
  primaryColor = 'primaryColor',
  showSaveSetButton = 'showSaveSetButton',
  showUploadSetButton = 'showUploadSetButton',
  showExerciseUnits = 'showExerciseUnits',
  onboardingEnabled = 'onboardingEnabled',
  showTooltips = 'showTooltips',
  trainingSetItemStatusListMode = 'trainingSetItemStatusListMode',
  defaultSetItemRestSec = 'defaultSetItemRestSec',
  notificationsSystemPushEnabled = 'notificationsSystemPushEnabled',
  notificationsSocialPushEnabled = 'notificationsSocialPushEnabled',
  notificationsMarketingPushEnabled = 'notificationsMarketingPushEnabled',
  notificationsRemindersPushEnabled = 'notificationsRemindersPushEnabled',
}

export enum TrainingSetItemStatusListMode {
  all = 'all',
  primary = 'primary',
}

export enum PrimaryColor {
  orange = 'orange',
  blue = 'blue',
  red = 'red',
  green = 'green',
  purple = 'purple',
  burgundy = 'burgundy',
  forest = 'forest',
}

export const defaultPrimaryColorKey = PrimaryColor.orange;

export enum ThemeMode {
  light = 'light',
  dark = 'dark',
}

export enum AppFeatureKey {
  subscriptions = 'SUBSCRIPTIONS',
  donations = 'DONATIONS',
  restrictions = 'RESTRICTIONS',
  resourses = 'RESOURSES',
  sharingExercises = 'SHARING_EXERCISES',
  appleAuthorization = 'APPLE_AUTHORIZATION',
  facebookAuthorization = 'FACEBOOK_AUTHORIZATION',
  aiGeneration = 'AI_GENERATION',
}

export const actionsWidth = 40;
export const sideColumnWidth = 20;
export const typeColumnWidth = 40;
export const setsColumnWidth = 60;
